import { controllerValuesEqual } from '../../util/controllerValuesEqual';

const caculateMixerScore = (activeInterface) => {
   const { correct: correctCount, checked: checkedCount } =
      activeInterface.instrumentRack.reduce(
         ({ correct, checked }, track) => {
            const updatedResults = {
               correct,
               checked,
            };
            // Check Gain
            if (!track.mixerTrack.gain.disabled) {
               updatedResults.checked += 1;
               updatedResults.correct += controllerValuesEqual(
                  track.mixerTrack.gain.value,
                  track.referenceMixerTrack.gain.value
               );
            }

            // Check Pan... if reference gain is 0, don't check pan
            if (
               !track.mixerTrack.pan.disabled &&
               track.referenceMixerTrack.gain.value !== 0
            ) {
               updatedResults.checked += 1;
               updatedResults.correct += controllerValuesEqual(
                  track.mixerTrack.pan.value,
                  track.referenceMixerTrack.pan.value
               );
            }

            return updatedResults;
         },
         {
            correct: 0,
            checked: 0,
         }
      );

   return (correctCount / checkedCount) * 100;
};

export { caculateMixerScore };
